// src/components/templates/MembershipTemplate.js

import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";

const MembershipTemplate = ({ children }) => (
  <Box
    sx={{
      maxWidth: "800px",
      margin: "0 auto", // Centers the box horizontally
      padding: 2, // Equivalent to 16px (MUI's default spacing unit is 8px)
      mt: 4, // Adds top margin (32px)
      px: { xs: 2, sm: 3, md: 4 }, // Responsive horizontal padding
    }}
  >
    <Typography
      variant="h4" // Adjust the variant as needed (e.g., h3, h5)
      component="h1"
      gutterBottom // Adds bottom margin
      sx={{
        fontFamily: "basic-sans",
        fontWeight: "bold",
        color: "white", 
        fontSize: {
          xs: "1rem", // Mobile devices
          sm: "1.5rem", // Tablets
          md: "1.8rem", // Small desktops
          lg: "2.2rem", // Large desktops
        },
        textAlign: "center", 
      }}
    >
      Creator's Alliance Program Membership
    </Typography>
    {children}
  </Box>
);

MembershipTemplate.propTypes = {
  children: PropTypes.node.isRequired,
};

export default MembershipTemplate;
